export class ResetPasswordError extends Error {}
